import React, { useContext, useEffect, useState } from "react";
import {
  TextField,
  MenuItem,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import {
  obtenerPaises,
  obtenerDocumentos,
  obtenerDatosHotel,
  datosPax,
} from "../../services/motorService";
import Cookies from "js-cookie";
import CheckoutContext from "../contexts/CheckoutContext";
import { useSearchParams } from "react-router-dom";
import { Autocomplete } from "@mui/material";
import { useLocation } from "react-router-dom";

const PersonalData = ({ setIsFormValid }) => {
  const { formValues, setFormValues, rutCliente, showLecturaRut } =
    useContext(CheckoutContext);

  const [emailTouched, setEmailTouched] = useState(false);
  const [phoneTouched, setPhoneTouched] = useState(false);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const hotcodParam = params.get("hotcod");
  const hotcod = hotcodParam ?? Cookies.get("hotCod") ?? null;

  const [datosHotel, setDatosHotel] = useState([]);
  const [country, setCountries] = useState([]);
  const [documents, setDocuments] = useState([]);

  const [documentoPorDefecto, setDocumento] = useState("");
  const [paisPorDefecto, setPais] = useState("");

  const [fechaBloqueada, setFechaBloqueada] = useState(false);
  const [nombreBloqueado, setNombreBloqueado] = useState(false);
  const [apellidoBloqueado, setApellidoBloqueado] = useState(false);
  const [direcBloqueado, setDirecBloqueado] = useState(false);
  const [documentoBloqueado, setDocumentoBloqueado] = useState(false);
  const [tipoDocBloqueado, setTipoDocBloqueado] = useState(false);
  const [paisBloqueado, setPaisBloqueado] = useState(false);
  const [telefonoBloqueado, setTelefonoBloqueado] = useState(false);
  const [correoBloqueado, setCorreoBloqueado] = useState(false);

  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const fromWebPay = status === "AUTHORIZED" || status === "FAILED";

  const BANCO_ESTADO_HOTELS = [
    "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "60"
  ];

  const jwe = params.get("t");
  const esBancoEstado = BANCO_ESTADO_HOTELS.includes(String(hotcod));



  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validatePhone = (phone) => {
    const regex = /^[0-9]+$/;
    return regex.test(phone);
  };

  const limpiarDato = (dato) => {
    if (!dato || dato === "NULL" || dato === null) return "";
    return dato;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });

    if (name === "correoElectronico") {
      setEmailTouched(true);
    } else if (name === "reservatelefono") {
      setPhoneTouched(true);
    }
  };

  // ✅ NO permitir seleccionar desde HOY en adelante (máximo: AYER)
  const handleDateChange = (date) => {
    if (date && date.isValid()) {
      const selected = dayjs(date).startOf("day");
      const today = dayjs().startOf("day");

      // Bloquea HOY y FUTURO
      if (!selected.isBefore(today)) {
        setFormValues({
          ...formValues,
          reservafechanacimiento: null,
        });
        return;
      }

      // Guardar en UTC (como ya hacías)
      const utcDate = selected.toDate();
      setFormValues({
        ...formValues,
        reservafechanacimiento: utcDate,
      });
    } else {
      setFormValues({
        ...formValues,
        reservafechanacimiento: null,
      });
    }
  };



  useEffect(() => {
    console.log("en personal data para ver si viene del webpay:", fromWebPay);
    if (fromWebPay) return;

    const initData = async () => {
      try {
        // 1. Obtener datos del hotel una sola vez
        const data = await obtenerDatosHotel(hotcod);
        console.log("Datos del hotel:", data);
        setDatosHotel(data);

        const hotCodAdmintour = data.MotorHotAdmintour;

        // 2. Obtener países y documentos una sola vez
        const paises = await obtenerPaises(hotCodAdmintour);
        setCountries(paises.ColeccionPais);

        const documentos = await obtenerDocumentos(hotCodAdmintour);
        console.log("Documentos:", documentos);
        setDocuments(documentos.ColeccionTipoDocumento);

        // 3.0 Banco estado
        if (esBancoEstado && jwe) {
          const response = await fetch(
            "https://gx18v2.admintour.com/jwe_decrypt/jwe/decrypt",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ jwe }),
            }
          );

          if (!response.ok) {
            throw new Error("No se pudo desencriptar el JWE.");
          }

          const dataJwe = await response.json();
          const rut = dataJwe?.rut || "";

          if (!rut) {
            throw new Error("El JWE no devolvió RUT.");
          }

          const datos = await datosPax(hotCodAdmintour, rut);
          const pax = datos?.DatosDocumento?.[0];

          if (!pax) {
            throw new Error("No se encontraron datos del pasajero.");
          }

          const nombreTitular = limpiarDato(pax.NombrePax);
          const apellidoTitular = limpiarDato(pax.ApellidoPax);
          const documentoTitular = limpiarDato(pax.PaxDocumento);
          const fechaNacimientoPax = pax.FechaNacimientoPax;
          const direccionTitular = limpiarDato(pax.DireccionPax);
          const tipoDocumentoTitular = pax.PaxTipoDocumento;
          const paisTitular = pax.NacionalidadPax;

          const telefonoTitular = limpiarDato(pax.TelefonoPax || pax.PaxTelefono);
          const correoTitular = limpiarDato(pax.EmailPax || pax.PaxEmail || pax.CorreoPax);


          const esFechaValida =
            fechaNacimientoPax &&
            fechaNacimientoPax !== "0000-00-00" &&
            fechaNacimientoPax !== "NULL";

          const documentoDescripcion = documentos.ColeccionTipoDocumento.find(
            (doc) => doc.TipoDocCodigo === tipoDocumentoTitular
          );
          setDocumento(documentoDescripcion);

          const paisesDescripcion = paises.ColeccionPais.find(
            (p) => p.HotelPaisCodigo === paisTitular
          );
          setPais(paisesDescripcion);

          setNombreBloqueado(true);
          setApellidoBloqueado(true);
          setDocumentoBloqueado(true);
          setTipoDocBloqueado(true);
          setPaisBloqueado(true);
          setDirecBloqueado(true);
          setFechaBloqueada(true);
          if (telefonoTitular) {
            setTelefonoBloqueado(true);
          }

          if (correoTitular) {
            setCorreoBloqueado(true);
          }

          setFormValues((prev) => ({
            ...prev,
            motorreservanombretitular: nombreTitular,
            motorreservaapellidotitular: apellidoTitular,
            reservanombre: `${nombreTitular} ${apellidoTitular}`.trim(),
            reservadocumento: documentoTitular,
            reservadireccion: direccionTitular,
            reservafechanacimiento: esFechaValida ? fechaNacimientoPax : null,
            reservatipodocumento: tipoDocumentoTitular,
            reservapais: paisTitular,
            reservatelefono: telefonoTitular,
            correoElectronico: correoTitular,
          }));

          return;
        }

        // 3. Si corresponde, obtener datosPax por RUT
        if (showLecturaRut && rutCliente?.datosCliente?.rut) {
          console.log(
            "Ejecutando datosPax con hotel:",
            hotCodAdmintour,
            "y rut:",
            rutCliente.datosCliente.rut
          );
          const datos = await datosPax(
            hotCodAdmintour,
            rutCliente.datosCliente.rut
          );
          console.log("Datos desde datosPax:", datos);

          const documentoDescripcion = documentos.ColeccionTipoDocumento.find(
            (doc) =>
              doc.TipoDocCodigo === datos.DatosDocumento[0].PaxTipoDocumento
          );
          console.log("docuentos con la descripcion", documentoDescripcion);
          setDocumento(documentoDescripcion);

          const paisesDescripcion = paises.ColeccionPais.find(
            (p) => p.HotelPaisCodigo === datos.DatosDocumento[0].NacionalidadPax
          );
          setPais(paisesDescripcion);
          console.log("pais descripcion", paisesDescripcion);

          // Seteo los datos solo si vienen
          if (datos) {
            console.log("documentos", documentos);
            console.log("ENTRO A SETEAR LOS DATOS");
            console.log(
              "datos que trae del documento",
              datos.DatosDocumento[0].PaxTipoDocumento
            );

            const nombreTitular = limpiarDato(datos.DatosDocumento[0].NombrePax);
            const apellidoTitular = limpiarDato(
              datos.DatosDocumento[0].ApellidoPax
            );
            const documentoTitular = limpiarDato(
              datos.DatosDocumento[0].PaxDocumento
            );
            const fechaNacimientoPax =
              datos.DatosDocumento[0].FechaNacimientoPax;
            const direccionTitular = limpiarDato(
              datos.DatosDocumento[0].DireccionPax
            );
            const tipoDocumentoTitular =
              datos.DatosDocumento[0].PaxTipoDocumento;

            const paisTitular = datos.DatosDocumento[0].NacionalidadPax;

            const esFechaValida =
              fechaNacimientoPax &&
              fechaNacimientoPax !== "0000-00-00" &&
              fechaNacimientoPax !== "NULL";
            const esNombreValido = nombreTitular != "";
            const esApellidoValido = apellidoTitular != "";
            const esDocumentoValido = documentoTitular != "";
            const esDireccionValida = direccionTitular != "";
            const esTipoDocValido = tipoDocumentoTitular != "";
            const esPaisValido = paisTitular != "";

            console.log("nomrbe titular valido", esNombreValido);
            if (esFechaValida) setFechaBloqueada(true);
            if (esNombreValido) setNombreBloqueado(true);
            if (esApellidoValido) setApellidoBloqueado(true);
            if (esDocumentoValido) setDocumentoBloqueado(true);
            if (esDireccionValida) setDirecBloqueado(true);
            if (esTipoDocValido) setTipoDocBloqueado(true);
            if (esPaisValido) setPaisBloqueado(true);

            setFormValues((prev) => ({
              ...prev,
              motorreservanombretitular: nombreTitular,
              motorreservaapellidotitular: apellidoTitular,
              reservadocumento: documentoTitular,
              reservadireccion: direccionTitular,
              reservafechanacimiento: esFechaValida ? fechaNacimientoPax : null,
              reservatipodocumento: tipoDocumentoTitular,
              reservapais: paisTitular,
              correoElectronico: "", // Editable
              reservatelefono: "", // Editable
            }));
          }
        }

        // 4. Hotel 27: precargar datos del cliente desde rutCliente
        if (String(hotcod) === "27" && rutCliente?.DatosDocumento?.length) {
          const datos = rutCliente;

          const documentoDescripcion = documentos.ColeccionTipoDocumento.find(
            (doc) => doc.TipoDocCodigo === datos.DatosDocumento[0].PaxTipoDocumento
          );
          setDocumento(documentoDescripcion);

          const paisesDescripcion = paises.ColeccionPais.find(
            (p) =>
              p.HotelPaisCodigo === datos.DatosDocumento[0].NacionalidadPax
          );
          setPais(paisesDescripcion);

          const nombreTitular = limpiarDato(datos.DatosDocumento[0].NombrePax);
          const apellidoTitular = limpiarDato(datos.DatosDocumento[0].ApellidoPax);
          const documentoTitular = limpiarDato(datos.DatosDocumento[0].PaxDocumento);
          const fechaNacimientoPax = datos.DatosDocumento[0].FechaNacimientoPax;
          const direccionTitular = limpiarDato(datos.DatosDocumento[0].DireccionPax);
          const tipoDocumentoTitular = datos.DatosDocumento[0].PaxTipoDocumento;
          const paisTitular = datos.DatosDocumento[0].NacionalidadPax;

          const esFechaValida =
            fechaNacimientoPax &&
            fechaNacimientoPax !== "0000-00-00" &&
            fechaNacimientoPax !== "NULL";
          const esNombreValido = nombreTitular != "";
          const esApellidoValido = apellidoTitular != "";
          const esDocumentoValido = documentoTitular != "";
          const esDireccionValida = direccionTitular != "";
          const esTipoDocValido = tipoDocumentoTitular != "";
          const esPaisValido = paisTitular != "";

          if (esFechaValida) setFechaBloqueada(true);
          if (esNombreValido) setNombreBloqueado(true);
          if (esApellidoValido) setApellidoBloqueado(true);
          if (esDocumentoValido) setDocumentoBloqueado(true);
          if (esDireccionValida) setDirecBloqueado(true);
          if (esTipoDocValido) setTipoDocBloqueado(true);
          if (esPaisValido) setPaisBloqueado(true);

          setFormValues((prev) => ({
            ...prev,
            motorreservanombretitular: nombreTitular,
            motorreservaapellidotitular: apellidoTitular,
            reservadocumento: documentoTitular,
            reservadireccion: direccionTitular,
            reservafechanacimiento: esFechaValida ? fechaNacimientoPax : null,
            reservatipodocumento: tipoDocumentoTitular,
            reservapais: paisTitular,
            correoElectronico: "", // Editable
            reservatelefono: "", // Editable
          }));
        }
      } catch (error) {
        console.error("Error inicializando datos:", error);
      }
    };

    initData(); // Se ejecuta una sola vez al inicio
  }, [hotcod, rutCliente, showLecturaRut, setFormValues]);

  useEffect(() => {
    console.log("en personal data para ver si viene del webpay:", fromWebPay);
    if (fromWebPay) return;

    console.log("Form Values en personal data: ", formValues);
    const isValid =
      formValues.motorreservanombretitular.trim() &&
      formValues.motorreservaapellidotitular.trim() &&
      formValues.reservatipodocumento &&
      formValues.reservadocumento.trim() &&
      formValues.reservatelefono.trim() &&
      validatePhone(formValues.reservatelefono) &&
      formValues.correoElectronico.trim() &&
      validateEmail(formValues.correoElectronico) &&
      formValues.reservadireccion.trim() &&
      formValues.reservafechanacimiento &&
      formValues.reservapais;

    setIsFormValid(isValid);
  }, [formValues]);

  return (
    <Grid container spacing={2} sx={{ paddingBottom: 4 }}>
      <Grid item xs={12} sm={6}>
        <TextField
          name="motorreservanombretitular"
          required
          fullWidth
          label="Nombre"
          value={formValues.motorreservanombretitular}
          onChange={handleInputChange}
          disabled={nombreBloqueado}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          name="motorreservaapellidotitular"
          required
          fullWidth
          label="Apellido"
          value={formValues.motorreservaapellidotitular}
          onChange={handleInputChange}
          disabled={apellidoBloqueado}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        {documentoPorDefecto ? (
          <TextField
            label="Tipo de documento"
            value={
              documents.find(
                (doc) => doc.TipoDocCodigo === documentoPorDefecto.TipoDocCodigo
              )?.TipoDocDescripcion || ""
            }
            fullWidth
            disabled={tipoDocBloqueado}
          />
        ) : (
          <TextField
            name="reservatipodocumento"
            required
            fullWidth
            select
            label="Tipo de documento"
            value={formValues.reservatipodocumento}
            onChange={handleInputChange}
          >
            {documents.map((option) => (
              <MenuItem key={option.TipoDocCodigo} value={option.TipoDocCodigo}>
                {option.TipoDocDescripcion}
              </MenuItem>
            ))}
          </TextField>
        )}
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          name="reservadocumento"
          required
          fullWidth
          label="N° documento"
          value={formValues.reservadocumento}
          onChange={handleInputChange}
          disabled={documentoBloqueado}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          name="reservatelefono"
          required
          fullWidth
          label="Teléfono"
          value={formValues.reservatelefono}
          onChange={handleInputChange}
          disabled={telefonoBloqueado}
          error={phoneTouched && !validatePhone(formValues.reservatelefono)}
          helperText={
            phoneTouched && !validatePhone(formValues.reservatelefono)
              ? "Teléfono inválido"
              : ""
          }
          type="tel"
          inputProps={{ pattern: "[0-9]*" }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          name="correoElectronico"
          required
          fullWidth
          label="Correo electrónico"
          value={formValues.correoElectronico}
          onChange={handleInputChange}
          disabled={correoBloqueado}
          error={emailTouched && !validateEmail(formValues.correoElectronico)}
          helperText={
            emailTouched && !validateEmail(formValues.correoElectronico)
              ? "Correo electrónico inválido"
              : ""
          }
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={
              formValues.reservafechanacimiento
                ? dayjs(formValues.reservafechanacimiento)
                : null
            }
            onChange={handleDateChange}
            label="Fecha de nacimiento"
            format="DD/MM/YYYY"
            disabled={fechaBloqueada}
            // ✅ máximo AYER => bloquea HOY y FUTURO
            maxDate={dayjs().subtract(1, "day").endOf("day")}
          />
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12} sm={6}>
        {paisPorDefecto ? (
          <TextField
            label="País"
            value={
              country.find(
                (c) => c.HotelPaisCodigo === paisPorDefecto.HotelPaisCodigo
              )?.HotelPaisNombre || ""
            }
            fullWidth
            disabled={paisBloqueado}
          />
        ) : (
          <Autocomplete
            options={country}
            getOptionLabel={(option) => option.HotelPaisNombre}
            value={
              country.find((c) => c.HotelPaisCodigo === formValues.reservapais) ||
              null
            }
            onChange={(event, newValue) => {
              handleInputChange({
                target: {
                  name: "reservapais",
                  value: newValue ? newValue.HotelPaisCodigo : "",
                },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="País"
                name="reservapais"
                required
                fullWidth
              />
            )}
          />
        )}
      </Grid>

      <Grid item xs={12}>
        <TextField
          name="reservadireccion"
          required
          fullWidth
          label="Dirección"
          value={formValues.reservadireccion}
          onChange={handleInputChange}
          disabled={direcBloqueado}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          name="reservaobservaciones"
          fullWidth
          label="Observaciones"
          multiline
          rows={2}
          value={formValues.reservaobservaciones}
          onChange={handleInputChange}
        />
      </Grid>

      <Grid item xs={12}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>¿Tiene vehículo?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="reservaautocolor"
                  fullWidth
                  label="Color del vehículo"
                  value={formValues.reservaautocolor}
                  onChange={handleInputChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  name="reservaautomarca"
                  fullWidth
                  label="Marca del vehículo"
                  value={formValues.reservaautomarca}
                  onChange={handleInputChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  name="reservaautomatricula"
                  fullWidth
                  label="Matrícula del vehículo"
                  value={formValues.reservaautomatricula}
                  onChange={handleInputChange}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
};

export default PersonalData;
